import Swiper, { Pagination } from 'swiper';

export default class Gallery {
  constructor() {
    this.classNames = {
      component: 'c-gallery',
      slider: 'c-gallery__swiper',
      body: 'c-gallery__slides',
      pagination: 'c-gallery__pagination',
    };

    this.components = Array.from(document.querySelectorAll(`.${this.classNames.component}`));
  }

  init() {
    if (this.components.length === 0) return;

    this.components.forEach((component) => {
      this.initSwiper({ component });
    });
  }

  initSwiper({ component }) {
    const pagination = component.querySelector(`.${this.classNames.pagination}`);
    const sliderEl = component.querySelector(`.${this.classNames.slider}`);

    Swiper.use([Pagination]);

    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      autoHeight: true,
      pagination: {
        el: pagination,
        clickable: true,
      },
    });
  }
}




// WEBPACK FOOTER //
// ./scripts/components/gallery.js